export const ConfigMapKeys = {
  CATEGORY_JSON: "category_json",
  SERVICE_JSON: "service_json",
  ROLE_JSON: "role_json",
  DOCUMENT_JSON: "document_json",
  TERRITORY_JSON: "territory_json",
} as const;

export type ConfigMapKey = keyof typeof ConfigMapKeys;
